export default __webpack_public_path__ + "static/media/922552c3b486750d06530594c5510d0f.svg";